<template>
  <div class="cgPhone">
    <el-input class="input old_phone" v-model="old_phone" placeholder="请输入旧密码"></el-input>
    <div class="verifyCode">
      <el-input class="input" maxlength="6" v-model="old_verifyCode" placeholder="请输入验证码"></el-input>
      <div class="butn">发送验证码</div>
    </div>
     <el-input class="input new_phone" v-model="new_phone" placeholder="请输入手机号码"></el-input>
     <div class="verifyCode">
      <el-input class="input" maxlength="6" v-model="new_verifyCode" placeholder="请输入验证码"></el-input>
      <div class="butn">发送验证码</div>
    </div>
    <div class="account-butn">确认更改</div>
  </div>
</template>

<script>
export default {
    data(){
        return{
old_phone:"",
new_phone:"",
new_verifyCode:"",
old_verifyCode:""
        }
    }
};
</script>

<style scoped type="text/css">
.old_phone{
    background-image: url(~@/assets/img/account/ico_oldcode.png);
}
.new_phone{
     background-image: url(~@/assets/img/account/icon_phone.png);
}
.verifyCode {
  display: flex;
   width: 281px;
  margin-top: 14px;
  justify-content: space-between;
  font-size: 14px;
  align-items: center;
}
.verifyCode .input {
  width: 166px;
  background-image: url(~@/assets/img/account/icon_code.png);
  margin: 0;
}
.verifyCode .butn {
  width: 99px;
  height: 32px;
  border-radius: 5px;
  opacity: 0.35;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 1);
  line-height: 32px;
}
.verifyCode .butn.on {
  background: rgba(255, 255, 255, 0.35);
}
</style>
<style>
</style>